<template>
	<v-dialog :fullscreen="isMobile" scrollable attach ref="purchaseAddonSuccessModal" v-model="open" max-width="700px">
		<v-card raised v-if="getEvent">
			<v-card-title class="display-1 modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="open=false">
					<v-icon large>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding">
				<div>
					<p class="mb-3 event-rsvp-success__header">
						Thank you {{ user.first_name }}!
					</p>
					<p class="event-rsvp-success__content mt-2">You have purchased ${{getEvent.addons[0].price}} {{getEvent.addons[0].title}} {{getEvent.addons[0].time_slot}} the event from {{getEvent.addons[0].start_time}} to {{getEvent.addons[0].end_time}}</p>
					<p class="event-rsvp-success__content">Your host will inform you when it is time to start. Enjoy!</p>
				</div>
				<div>
					<img class="event-page-flat-logo" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import AddToCalendar from '~/components/AddToCalendar.vue'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'event_rsvp_success_modal',
	data() {
		return {}
	},
	components: {
		AddToCalendar
	},
	methods: {
		...mapActions([
			'setShareModalEvent',
			'setModalOpen',
			'setModalProp',
			'setCalendarModalEvent'
		]),
		clickWrkprtyLogo() {
			this.open = false
			this.$router.push('/dashboard')
		},
		timeToAMPM(timeString) {
			let time = timeString
				.toString()
				.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [timeString]

			if (time.length > 1) {
				time = time.slice(1)
				if (time.length > 3) {
					time.pop()
				}
				time[3] = time[0] < 12 ? 'a' : 'p'
				time[0] = +time[0] % 12 || 12
			}
			// console.log(time)
			return time.join('')
		},
		openShareModal() {
			this.setShareModalEvent(this.getEvent)
			this.setModalOpen({ prop: 'shareModal', value: true })
			console.log('open share modal')
		},
		openAddToCalendarModal() {
			this.setModalOpen({ prop: 'calendarModal', value: true })
			this.setCalendarModalEvent(this.getEvent)
		}
	},
	computed: {
		...mapGetters([
			'user',
			'getAllEvents',
			'getEventRSVPSuccessModalEvent',
			'getModalProp'
		]),
		requiresApproval() {
			if (this.getEvent.restrictions.approval === 'all_need_approval') {
				return true
			}
			if (this.getEvent.restrictions.approval === 'level_one') {
				return true
			}
		},
		getPrice () {
			// axios.get('/api/v1/payment-object/' + this.getEvent.pk + '/user/' + this.user.pk + '/').then((response) => {
			// 	console.log(response)
			// 	console.log('asdaasdff')
			// }).catch((error) => {
			// 	console.log(error)
			// })
			let price = 0.0
			// if (this.getModalProp('eventRSVPSuccessModalAddons') !== null) {
			// 	if (this.getModalProp('eventRSVPSuccessModalAddons').length > 0) {
			// 		price += parseFloat(this.getModalProp('eventRSVPSuccessModalAddons')[0].price)
			// 	}
			// }
			price += this.getEvent.final_price
			return price
		},
		getLocationAddress() {
			let locationString = ''
			if (this.location.hasOwnProperty('address')) {
				let addressComponents = []
				if (this.location.address.hasOwnProperty('street_number')) {
					if (this.location.address.hasOwnProperty('route')) {
						addressComponents.push(
							this.location.address.street_number +
								' ' +
								this.location.address.route
						)
					}
				}
				if (this.location.address.hasOwnProperty('city')) {
					addressComponents.push(this.location.address.city)
				}
				if (this.location.address.hasOwnProperty('state')) {
					addressComponents.push(this.location.address.state)
				}
				if (this.location.address.hasOwnProperty('country')) {
					if (this.location.address.country !== 'United States') {
						addressComponents.push(this.location.address.country)
					}
				}
				for (var i = 0; i < addressComponents.length; i++) {
					locationString += addressComponents[i]
					if (i < addressComponents.length - 1) {
						locationString += ', '
					}
				}
			}
			return locationString
		},
		location() {
			return this.getEvent.location
		},
		eventDate() {
			return moment(this.getEvent.date).format('MMM Do')
		},
		formattedTime() {
			let start = this.timeToAMPM(this.getEvent.time_start)
			let end = this.timeToAMPM(this.getEvent.time_end)

			if (!start || !end) {
				return ''
			}

			let startSuffix = ''
			let endSuffix = ''

			if (start.includes('a')) {
				startSuffix = 'a'
			} else {
				startSuffix = 'p'
			}

			if (end.includes('a')) {
				endSuffix = 'a'
			} else {
				endSuffix = 'p'
			}

			return (
				start.split(':')[0] +
				startSuffix +
				' - ' +
				end.split(':')[0] +
				endSuffix
			)
		},
		getEvent() {
			return this.getAllEvents.find(
				obj => obj.pk === this.getEventRSVPSuccessModalEvent
			)
		},
		open: {
			get() {
				return this.getModalProp('purchaseAddonSuccessModal')
			},
			set(value) {
				this.setModalOpen({ prop: 'purchaseAddonSuccessModal', value: value })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		},
	}
}
</script>

<style lang="scss">
.event-rsvp-success__header {
	font-size: 1.8em;
	font-family: 'Quantico';
	color: #666;
}

.event-rsvp-success__content {
	font-size: 0.9em;
	color: #777;
}
.event-rsvp-success__sub-header {
	font-size: 1em;
	color: #999;
}
</style>
